import React from 'react';
import PropTypes from 'prop-types';
import { Icon, grey600 } from '@paypalcorp/pp-react';
import { StyleSheet, css } from '../../utility/paypalAphrodite';

const styles = StyleSheet.create({
  iconLink: {
    cursor: 'pointer',
    color: grey600,
    marginRight: '0.375rem',
  },
});

function SocialShareMobile({ handleMobileClick }) {
  return (
    <Icon
      name="share-mobile"
      onClick={handleMobileClick}
      className={`ppvx_icon--size_lg ${css(styles.iconLink)}`}
      data-testid="social-share-mobile"
    />
  );
}

SocialShareMobile.propTypes = {
  handleMobileClick: PropTypes.func,
};

export default SocialShareMobile;
